<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-33">
      <validation-field :validations="{ required: true }" name="term name">
        <label>{{ $t("term.term_name") }}</label>
        <md-input
          v-model.trim="formData.name"
          :readonly="isReadOnly"
          required
        ></md-input>
        <span class="md-error" v-if="serverValidations.name">{{
          serverValidations.name
        }}</span>
      </validation-field>
    </div>

    <div class="md-layout-item md-size-33">
      <validation-field :validations="{ required: true }" name="school year">
        <label>{{ $t("student.school_year") }}</label>
        <md-select
          v-model="formData.school_year"
          name="school_year"
          id="school_year"
          required
          :readonly="isReadOnly"
        >
          <md-option
            v-for="schoolYear in schoolYears"
            :key="schoolYear.id"
            :value="schoolYear.name"
            >{{ schoolYear.name }}
          </md-option>
        </md-select>
        <span class="md-error" v-if="serverValidations.school_year">{{
          serverValidations.school_year
        }}</span>
      </validation-field>
    </div>

    <div class="md-layout-item md-size-33">
      <validation-field
        :validations="{ required: true }"
        name="semester number"
        :readonly="isReadOnly"
      >
        <label>{{ $t("term.semester_number") }}</label>
        <md-select
          v-model.number="formData.semester_number"
          name="semester_number"
          id="semester_number"
          required
        >
          <md-option :value="SEMESTER_1">Semester 1</md-option>
          <md-option :value="SEMESTER_2">Semester 2</md-option>
        </md-select>
        <span class="md-error" v-if="serverValidations.semester_number">{{
          serverValidations.semester_number
        }}</span>
      </validation-field>
    </div>
    <div
      class="md-layout-item md-size-33"
      v-if="Number(formData.semester_number) === SEMESTER_2"
    >
      <validation-field
        :validations="{ required: true }"
        name="reference semester"
      >
        <label>Reference semester</label>
        <md-select
          v-model="formData.ref_id"
          name="ref_id"
          id="ref_id"
          required
          :readonly="isReadOnly"
          :disabled="!formData.school_year"
        >
          <md-option
            v-for="term in reference_term"
            :key="term.id"
            :value="term.id"
            >{{ term.name }}
          </md-option>
        </md-select>
        <span class="md-error" v-if="serverValidations.ref_id">{{
          serverValidations.ref_id
        }}</span>
      </validation-field>
    </div>

    <div class="md-layout-item md-size-33">
      <md-field>
        <label>{{ $t("common.status") }}</label>
        <md-select
          v-model="formData.status"
          :readonly="isReadOnly"
          name="status"
          id="status"
        >
          <md-option value="On-going">{{ $t("common.on_going") }}</md-option>
          <md-option value="Concluded">{{ $t("common.concluded") }}</md-option>
        </md-select>
      </md-field>
    </div>

    <div class="md-layout-item md-size-33">
      <validation-field
        :validations="{ required: true }"
        name="start date"
        type="date-picker"
      >
        <template #default="{ errors }">
          <date-picker-custom
            :label="$t('common.start_date')"
            v-model="formData.start_date"
            required
          >
            <span class="md-error">{{ errors[0] }}</span>
          </date-picker-custom>
        </template>
        <span class="md-error" v-if="serverValidations.start_date">{{
          serverValidations.start_date
        }}</span>
      </validation-field>
    </div>

    <div class="md-layout-item md-size-33">
      <date-picker-custom
        :label="$t('common.end_date')"
        v-model="formData.end_date"
      >
      </date-picker-custom>
    </div>

    <div class="md-layout-item md-size-33">
      <md-field>
        <label>{{ $t("common.description") }}</label>
        <md-input v-model.trim="formData.description"></md-input>
      </md-field>
    </div>
  </div>
</template>
<script>
import { service_paths } from "@/constants/Services";
import { Message } from "../../helpers/utils";
import { SCHOOL_YEARS } from "../../constants";

export default {
  name: "term-info-form",
  props: ["isEdit", "termData", "serverValidations", "isReadOnly"],
  data() {
    return {
      SEMESTER_1: 1,
      SEMESTER_2: 2,
      schoolYears: SCHOOL_YEARS,
      defaultForm: {
        name: null,
        status: "On-going",
        school_year: null,
        semester_number: 1,
        ref_id: null,
        start_date: null,
        end_date: null,
        description: null
      },
      formData: {},
      reference_term: []
    };
  },
  watch: {
    termData() {
      this.formData = Object.assign({}, this.termData);
    },
    "formData.name"() {
      this.serverValidations.name && delete this.serverValidations.name;
    },
    "formData.school_year"(year) {
      if (year && Number(this.formData.semester_number) === this.SEMESTER_2)
        this.getTerms();

      this.serverValidations.school_year &&
        delete this.serverValidations.school_year;
    },
    "formData.semester_number"(number) {
      if (number === this.SEMESTER_2) this.getTerms();

      this.serverValidations.semester_number &&
        delete this.serverValidations.semester_number;
    },
    "formData.ref_id"() {
      this.serverValidations.ref_id && delete this.serverValidations.ref_id;
    },
    "formData.start_date"() {
      this.serverValidations.start_date &&
        delete this.serverValidations.start_date;
    }
  },
  methods: {
    getTerms() {
      this.$axios
        .get(`${service_paths.terms}`, {
          semester_number: this.SEMESTER_1,
          school_year: this.formData.school_year
        })
        .then(res => {
          if (res.data.data.length) {
            this.reference_term = res.data.data;
          } else {
            Message.error("This school year no semesters have been created!");
          }
        });
    }
  },
  created() {
    this.formData = Object.assign({}, this.defaultForm);
  }
};
</script>
